// extracted by mini-css-extract-plugin
export default {"card":"PetitionCard_card__DR8U7","icon":"PetitionCard_icon__d82HK","stats":"PetitionCard_stats__W+ggt","text":"PetitionCard_text__i8irr"};